import type { TranslateFunc } from 'src/components/translate';
import type { ProductCollectionPropertyColumn } from '../../../types';

// It's possible to toggle a product list column from most filter sections, but some columns can't
// be removed as they are part of the base set of columns, and some filters aren't supported as
// columns at all.
export const UNTOGGLABLE_PROPERTY_COLUMNS = [
  // These map to columns that can't be removed
  'lowestPrice',
  'in_stock',
  'user_reviews_rating',

  // Stores is not a real product property, and we don't handle it as a special case (unlike brand)
  'stores',
];

export function getPropertyColumnName(
  column: ProductCollectionPropertyColumn,
  t: TranslateFunc
): string {
  if (column.__typename === 'ProductCollectionTruePropertyColumn') {
    return column.name;
  }

  switch (column.id) {
    case 'brand':
      return t('category', 'product-list.brand-column-name');
    case 'deal_diff_percentage':
      return t('category', 'product-list.deal-diff-column-name');
    case 'days_since_indexing':
      return t('category', 'product-list.index-date-column-name');
    default:
      return '-';
  }
}
